<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用戶名/手機號，用於登錄" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="請輸入用戶名/手機號，用於登錄" />
      </a-form-model-item>
      <a-form-model-item label="密碼，md5" prop="password" >
        <a-input v-model="form.password" placeholder="請輸入密碼，md5" />
      </a-form-model-item>
      <a-form-model-item label="頭像鏈接" prop="avatar" >
        <a-input v-model="form.avatar" placeholder="請輸入頭像鏈接" />
      </a-form-model-item>
      <a-form-model-item label="暱稱" prop="nickname" >
        <a-input v-model="form.nickname" placeholder="請輸入暱稱" />
      </a-form-model-item>
      <a-form-model-item label="性別,0-保密 1-男 2-女" prop="sex" >
      </a-form-model-item>
      <a-form-model-item label="生日，格式1990-04-22" prop="birthday" >
      </a-form-model-item>
      <a-form-model-item label="用戶個性簽名" prop="userSign" >
        <a-input v-model="form.userSign" placeholder="請輸入用戶個性簽名" />
      </a-form-model-item>
      <a-form-model-item label="是否推送 1-是 0-否" prop="isNotice" >
        <a-input v-model="form.isNotice" placeholder="請輸入是否推送 1-是 0-否" />
      </a-form-model-item>
      <a-form-model-item label="用戶狀態，1-正常，0禁用，禁用操作請注意清除token，同時不允許用戶登錄" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="備註" prop="remark" >
        <a-input v-model="form.remark" placeholder="請輸入內容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="郵箱" prop="email" >
        <a-input v-model="form.email" placeholder="請輸入郵箱" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUser, addUser, updateUser } from '@/api/user/user'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表單參數
      form: {
        id: null,

        mobile: null,

        password: null,

        avatar: null,

        nickname: null,

        sex: null,

        birthday: null,

        userSign: null,

        isNotice: null,

        status: 0,

        createTime: null,

        remark: null,

        email: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        mobile: [
          { required: true, message: '用戶名/手機號，用於登錄不能為空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密碼，md5不能為空', trigger: 'blur' }
        ],
        avatar: [
          { required: true, message: '頭像鏈接不能為空', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '暱稱不能為空', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '性別,0-保密 1-男 2-女不能為空', trigger: 'change' }
        ],
        userSign: [
          { required: true, message: '用戶個性簽名不能為空', trigger: 'blur' }
        ],
        isNotice: [
          { required: true, message: '是否推送 1-是 0-否不能為空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '用戶狀態，1-正常，0禁用，禁用操作請注意清除token，同時不允許用戶登錄不能為空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按鈕
    cancel () {
      this.open = false
      this.reset()
    },
    // 表單重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        mobile: null,
        password: null,
        avatar: null,
        nickname: null,
        sex: null,
        birthday: null,
        userSign: null,
        isNotice: null,
        status: 0,
        createTime: null,
        remark: null,
        email: null
      }
   /*   this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })*/
    },
    /** 新增按鈕操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按鈕操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUser({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按鈕 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUser(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUser(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
